<template>
    <v-container fluid class="courts-page secondary-font">
        <v-row v-if="loading">
            <v-col v-for="n in 6" :key="n" cols="12" sm="6" md="4">
                <v-skeleton-loader type="image, list-item-two-line, actions" class="rounded-lg" />
            </v-col>
        </v-row>

        <v-row v-else>
            <v-col v-for="arena in sortedArenas" :key="arena.id" cols="12" sm="6" md="4">
                <v-card class="court-card rounded-lg">
                    <a
                        v-if="arena.position"
                        :href="getPlaceUrl(arena)"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="court-card__map"
                    >
                        <img
                            :src="getStaticMapUrl(arena.position)"
                            :alt="`Χάρτης: ${arena.name}`"
                            loading="lazy"
                        >
                    </a>
                    <div v-else class="court-card__map court-card__map--empty">
                        <v-icon x-large color="orange">mdi-basketball-hoop-outline</v-icon>
                    </div>

                    <div class="court-card__body">
                        <div class="court-card__name">
                            <v-icon color="orange" class="mr-1">mdi-basketball-hoop-outline</v-icon>
                            {{ arena.name }}
                        </div>
                        <div v-if="arena.address" class="court-card__address">
                            <v-icon small color="orange" class="mr-1">mdi-map-marker-outline</v-icon>
                            {{ arena.address }}
                        </div>
                    </div>

                    <div class="court-card__actions">
                        <v-btn
                            small
                            text
                            color="orange darken-2"
                            :disabled="!arena.position"
                            :href="arena.position ? getDirectionsUrl(arena) : undefined"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <v-icon small left>mdi-directions</v-icon>
                            Οδηγίες
                        </v-btn>
                        <v-spacer />
                        <v-btn small depressed class="custom-orange white--text" :to="{ name: 'Schedule', query: { arenaId: String(arena.id) } }">
                            <v-icon small left>mdi-calendar-month-outline</v-icon>
                            Αγώνες εδώ
                        </v-btn>
                    </div>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import arenaService from '@/services/arena'
    import { parseCoordinates, getStaticMapUrl } from '@/utils/googleMaps'

    export default {
        data() {
            return {
                arenas: [],
                loading: false
            }
        },
        computed: {
            sortedArenas() {
                return this.arenas
                    .map(arena => ({ ...arena, position: parseCoordinates(arena.coordinates) }))
                    .sort((a, b) => (a.name || '').localeCompare(b.name || '', 'el'))
            }
        },
        created() {
            this.fetchAllArenas()
        },
        methods: {
            getStaticMapUrl,
            fetchAllArenas() {
                this.loading = true
                arenaService.getArenas(1, 1000).then(resp => {
                    this.arenas = resp.data.content
                }).finally(() => {
                    this.loading = false
                })
            },
            getPlaceUrl(arena) {
                return `https://www.google.com/maps/search/?api=1&query=${arena.position.lat},${arena.position.lng}`
            },
            getDirectionsUrl(arena) {
                return `https://www.google.com/maps/dir/?api=1&destination=${arena.position.lat},${arena.position.lng}`
            }
        }
    }
</script>

<style scoped>
.courts-page {
    max-width: 1200px;
    margin: 0 auto;
}

/* ---------- Card ---------- */
.court-card {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.court-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15) !important;
}

.court-card__map {
    position: relative;
    display: block;
    aspect-ratio: 2 / 1;
    background: #eceff1;
    overflow: hidden;
}

.court-card__map img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.4s ease;
}

.court-card:hover .court-card__map img {
    transform: scale(1.04);
}

.court-card__map--empty {
    display: flex;
    align-items: center;
    justify-content: center;
}

.court-card__body {
    flex: 1 1 auto;
    padding: 14px 16px 6px;
}

.court-card__name {
    font-size: 1.15rem;
    font-weight: 700;
    line-height: 1.3;
}

.court-card__address {
    margin-top: 6px;
    color: rgba(0, 0, 0, 0.65);
    font-family: Ubuntu, Arial, sans-serif;
    font-size: 0.9rem;
    font-weight: 600;
}

.court-card__actions {
    display: flex;
    align-items: center;
    padding: 6px 12px 12px;
}

.court-card__actions .v-btn {
    font-family: Ubuntu, Arial, sans-serif;
    font-weight: 700;
    text-transform: none;
    letter-spacing: normal;
}
</style>
